import { useContext } from "react";
import GlobalContext from "@context/GlobalContext";

export default function useLoading() {
  const dispatch = useContext(GlobalContext)[1];

  const handleLoading = (status) => {
    dispatch({
      type: "SET_LOADING",
      payload: status,
    });
  };

  return [handleLoading];
}
